import type { UserPreferenceType } from '@atlassian/jira-dashboard-user-preference';
import type { ReactGadgetGetInitialState } from '@atlassian/jira-react-gadgets-common';
import { INITIAL_START_INDEX } from '../common/constants';
import { getProjects } from '../services';
import type { ProjectsGadgetData } from '../types';

const getInitialState: ReactGadgetGetInitialState<ProjectsGadgetData, UserPreferenceType[]> = (
	_,
	projectsGadgetPreferences: UserPreferenceType[],
) => getProjects(projectsGadgetPreferences, INITIAL_START_INDEX);

export default getInitialState;
